import React from 'react';
import WhatIsBitcoin from '../components/bitcoin/WhatIsBitcoin';
import BTMAdvantages from '../components/bitcoin/BTMAdvantages';
import SecurityTips from '../components/bitcoin/SecurityTips';
import GettingStarted from '../components/bitcoin/GettingStarted';

export default function BitcoinBasicsPage() {
  return (
    <div className="min-h-screen bg-gray-900 pt-20">
      <div className="container mx-auto px-4 py-12 space-y-16">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h1 className="text-4xl font-bold text-white mb-4">Bitcoin Basics</h1>
          <p className="text-xl text-gray-300">
            Your guide to understanding Bitcoin and how to get started
          </p>
        </div>
        <WhatIsBitcoin />
        <GettingStarted />
        <BTMAdvantages />
        <SecurityTips />
      </div>
    </div>
  );
}